import { Modal } from "react-bootstrap";

interface Props {
    isShown: boolean
    /** Daha önce hesaplanmış, aynı gün aynı gruptaki siparişlerin kayıt numaraları. */
    refNos: string[]
    /** "Evet": yalnız seçilen siparişler ayrı hesaplanır. */
    onSeparate: () => void
    /** "Hayır, Diğerleriyle Birlikte": önceki siparişler de gruba katılır ve yeniden hesaplanır. */
    onTogether: () => void
    onClose: () => void
}

/**
 * Günlük Bölüm Grubu: aynı gün aynı bölüm grubunda, fiyatı daha önce hesaplanmış ve henüz
 * faturalanmamış siparişler varsa kullanıcıya sorulur. Pencere kapatılırsa hesap yapılmaz.
 */
const PriceGroupDecisionModal = ({ isShown, refNos, onSeparate, onTogether, onClose }: Props) => {
    const shown = refNos.slice(0, 10);

    return (
        <Modal
            tabIndex={-1}
            aria-hidden='true'
            dialogClassName='modal-dialog modal-dialog-centered mw-600px'
            show={isShown}
            onHide={onClose}
            backdrop={'static'}
            keyboard={false}
        >
            <div className='modal-header'>
                <h2 className='mb-0'>Aynı gün aynı bölüm grubu</h2>
            </div>

            <div className='modal-body'>
                <div className='fs-5 fw-bold text-gray-800 mb-4'>
                    Aynı gün aynı Bölüme ait siparişler var, bunları ayrı hesaplatmak mı istiyorsunuz?
                </div>

                {
                    shown.length > 0 && (
                        <div className='text-gray-700 fs-7 mb-4'>
                            Daha önce fiyatı hesaplanmış (faturalanmamış) siparişler: {shown.join(', ')}{refNos.length > shown.length ? ` ve ${refNos.length - shown.length} sipariş daha` : ''}
                        </div>
                    )
                }

                <div className='text-gray-600 fs-7'>
                    <div><b>Evet:</b> yalnız seçtiğiniz siparişler kendi aralarında bölünür; önceki siparişlere dokunulmaz.</div>
                    <div><b>Hayır, Diğerleriyle Birlikte:</b> önceki siparişler de seçilmiş gibi gruba katılır, fiyat hepsine yeniden bölünür ve faturalanmamış satırları güncellenir.</div>
                </div>
            </div>

            <div className="modal-footer">
                <button onClick={onClose} type="button" className="btn btn-light">Vazgeç</button>
                <button onClick={onTogether} type="button" className="btn btn-light-primary">Hayır, Diğerleriyle Birlikte</button>
                <button onClick={onSeparate} type="button" className="btn btn-primary">Evet</button>
            </div>
        </Modal>
    )
}

export default PriceGroupDecisionModal;
